import React from "react";

const ProductDetailsSkeleton = () => {
  return (
    <div className="min-h-screen bg-white animate-pulse">
      {/* Breadcrumb */}
      <div className="bg-white border-b">
        <div className="w-full mx-auto px-4 md:px-10 py-2.5">
          <div className="h-3.5 w-40 bg-gray-200 rounded"></div>
        </div>
      </div>

      <div className="w-full mx-auto px-4 md:px-10 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-[420px_1fr_320px] gap-8">
          {/* LEFT — Thumbnails + Main image */}
          <div className="flex flex-col sm:flex-row gap-3">
            <div className="order-2 sm:order-1 flex sm:flex-col gap-2">
              {[1, 2, 3, 4, 5].map((i) => (
                <div
                  key={i}
                  className="flex-shrink-0 w-14 h-14 bg-gray-200 rounded-md"
                ></div>
              ))}
            </div>
            <div className="order-1 sm:order-2 flex-1">
              <div className="w-full aspect-square max-w-[420px] mx-auto bg-gray-200 rounded-lg"></div>
              <div className="h-3 w-28 bg-gray-200 rounded mx-auto mt-3"></div>
            </div>
          </div>

          {/* CENTER — Title / rating / table / description */}
          <div className="min-w-0 space-y-4">
            <div className="space-y-2">
              <div className="h-5 w-full bg-gray-200 rounded"></div>
              <div className="h-5 w-4/5 bg-gray-200 rounded"></div>
            </div>
            <div className="h-3.5 w-32 bg-gray-200 rounded"></div>

            <div className="flex items-center gap-2">
              <div className="h-3.5 w-8 bg-gray-200 rounded"></div>
              <div className="flex gap-1">
                {[1, 2, 3, 4, 5].map((i) => (
                  <div key={i} className="h-4 w-4 bg-gray-200 rounded-sm"></div>
                ))}
              </div>
              <div className="h-3.5 w-10 bg-gray-200 rounded"></div>
            </div>

            <hr />

            {/* Trust icon row */}
            <div className="flex gap-6">
              {[1, 2, 3].map((i) => (
                <div key={i} className="flex flex-col items-center w-16 gap-2">
                  <div className="h-6 w-6 bg-gray-200 rounded"></div>
                  <div className="h-2.5 w-12 bg-gray-200 rounded"></div>
                </div>
              ))}
            </div>

            {/* Spec table */}
            <div className="space-y-3 pt-2">
              {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                <div key={i} className="flex gap-4">
                  <div className="h-3.5 w-28 bg-gray-200 rounded"></div>
                  <div className="h-3.5 w-40 bg-gray-200 rounded"></div>
                </div>
              ))}
            </div>

            <hr />

            {/* About this item */}
            <div className="space-y-2">
              <div className="h-4 w-40 bg-gray-200 rounded"></div>
              <div className="h-3.5 w-full bg-gray-200 rounded"></div>
              <div className="h-3.5 w-full bg-gray-200 rounded"></div>
              <div className="h-3.5 w-3/4 bg-gray-200 rounded"></div>
            </div>
          </div>

          {/* RIGHT — Buy box */}
          <div className="min-w-0">
            <div className="border border-gray-200 rounded-xl p-4 space-y-3">
              <div className="h-8 w-32 bg-gray-200 rounded"></div>
              <div className="h-3.5 w-24 bg-gray-200 rounded"></div>
              <div className="h-3 w-20 bg-gray-200 rounded"></div>

              <div className="h-3.5 w-full bg-gray-200 rounded mt-3"></div>
              <div className="h-3.5 w-3/4 bg-gray-200 rounded"></div>

              <div className="h-4 w-16 bg-gray-200 rounded mt-2"></div>

              <div className="h-8 w-28 bg-gray-200 rounded-md mt-2"></div>

              <div className="flex flex-col gap-2 mt-3">
                <div className="h-10 w-full bg-gray-200 rounded-full"></div>
                <div className="h-10 w-full bg-gray-200 rounded-full"></div>
              </div>

              <div className="h-9 w-full bg-gray-200 rounded-full mt-1"></div>

              <hr />

              <div className="space-y-2 pt-1">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="flex justify-between">
                    <div className="h-3 w-16 bg-gray-200 rounded"></div>
                    <div className="h-3 w-24 bg-gray-200 rounded"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Reviews */}
        <div className="mt-16">
          <div className="h-7 w-56 bg-gray-200 rounded mb-6"></div>
          <div className="bg-white border rounded-lg p-6 h-20"></div>
        </div>

        {/* Related Products */}
        <div className="mt-16">
          <div className="h-7 w-56 bg-gray-200 rounded mb-6"></div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="bg-white rounded-lg h-72 shadow-sm overflow-hidden">
                <div className="bg-gray-200 aspect-square"></div>
                <div className="p-3 md:p-4 space-y-2">
                  <div className="h-3 w-20 bg-gray-200 rounded mx-auto"></div>
                  <div className="h-3 w-full bg-gray-200 rounded"></div>
                  <div className="h-3 w-2/3 bg-gray-200 rounded mx-auto"></div>
                  <div className="h-4 w-16 bg-gray-200 rounded mx-auto mt-2"></div>
                  <div className="h-9 w-full bg-gray-200 rounded-lg mt-3"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsSkeleton;